var _classCallCheck = require("/home/turner/Documents/ufsc/formais/BrunoMarques/aplicacao/autom4ta/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/turner/Documents/ufsc/formais/BrunoMarques/aplicacao/autom4ta/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/turner/Documents/ufsc/formais/BrunoMarques/aplicacao/autom4ta/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/turner/Documents/ufsc/formais/BrunoMarques/aplicacao/autom4ta/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/turner/Documents/ufsc/formais/BrunoMarques/aplicacao/autom4ta/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/home/turner/Documents/ufsc/formais/BrunoMarques/aplicacao/autom4ta/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var utils = require('./utils');

var tableLayout = require('./layout-manager');

var Table =
/*#__PURE__*/
function (_Array) {
  "use strict";

  _inherits(Table, _Array);

  function Table(options) {
    var _this;

    _classCallCheck(this, Table);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Table).call(this));
    _this.options = utils.mergeOptions(options);
    return _this;
  }

  _createClass(Table, [{
    key: "toString",
    value: function toString() {
      var array = this;
      var headersPresent = this.options.head && this.options.head.length;

      if (headersPresent) {
        array = [this.options.head];

        if (this.length) {
          array.push.apply(array, this);
        }
      } else {
        this.options.style.head = [];
      }

      var cells = tableLayout.makeTableLayout(array);
      cells.forEach(function (row) {
        row.forEach(function (cell) {
          cell.mergeTableOptions(this.options, cells);
        }, this);
      }, this);
      tableLayout.computeWidths(this.options.colWidths, cells);
      tableLayout.computeHeights(this.options.rowHeights, cells);
      cells.forEach(function (row) {
        row.forEach(function (cell) {
          cell.init(this.options);
        }, this);
      }, this);
      var result = [];

      for (var rowIndex = 0; rowIndex < cells.length; rowIndex++) {
        var row = cells[rowIndex];
        var heightOfRow = this.options.rowHeights[rowIndex];

        if (rowIndex === 0 || !this.options.style.compact || rowIndex == 1 && headersPresent) {
          doDraw(row, 'top', result);
        }

        for (var lineNum = 0; lineNum < heightOfRow; lineNum++) {
          doDraw(row, lineNum, result);
        }

        if (rowIndex + 1 == cells.length) {
          doDraw(row, 'bottom', result);
        }
      }

      return result.join('\n');
    }
  }, {
    key: "width",
    get: function get() {
      var str = this.toString().split('\n');
      return str[0].length;
    }
  }]);

  return Table;
}(_wrapNativeSuper(Array));

function doDraw(row, lineNum, result) {
  var line = [];
  row.forEach(function (cell) {
    line.push(cell.draw(lineNum));
  });
  var str = line.join('');
  if (str.length) result.push(str);
}

module.exports = Table;